<template>
    <div v-if="shouldShowMessage" class="notification-container">
        <font-awesome-icon :icon="['fas', 'fa-key']" />
        <p>
            <b>API Key Needed:</b> This image effect requires an API Key. Please set it up in
            <a href="/account/integrations" target="_blank" rel="noopener noreferrer">Account Integrations</a>
            if you haven't done so already.
        </p>
    </div>
</template>

<script setup lang="ts">
import { ImageEffectPreset } from '@/components/DesignStudio/ImageEffectsProperties/types/presets';
import { computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

interface Props {
    preset?: ImageEffectPreset;
    isFree?: boolean;
}

const props = defineProps<Props>();

const shouldShowMessage = computed(() => {
    return props.preset !== undefined ? !props.preset?.isFree : !props.isFree;
});
</script>

<style scoped lang="scss">
.notification-container {
    border: 1px #c54400 solid;
    border-radius: 8px;
    padding: 10px 12px;
    background: #fff2e5;
    font-weight: 700;
    display: flex;
    align-items: center;

    svg {
        margin-right: 10px;
    }

    p {
        margin: 0;
    }
}
</style>
